import React from "react";

interface ExternalLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string;
  children: React.ReactNode;
}

const normalizeUrl = (to: string) => {
  if (!to) return "#";
  let url = to.trim();

  // Remove accidental spaces and fix common mistakes
  url = url.replace(/^https?\s*\/\//, ""); // Remove malformed protocol
  url = url.replace(/^\/+/, ""); // Remove leading slashes

  // Add protocol if missing
  if (!/^https?:\/\//i.test(url)) {
    url = "https://" + url;
  }
  return url;
};

const ExternalLink: React.FC<ExternalLinkProps> = ({
  to,
  children,
  ...props
}) => {
  const url = normalizeUrl(to);
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" {...props}>
      {children}
    </a>
  );
};

export default ExternalLink;
